import { put, select } from 'redux-saga/effects';

import { SAVE_FILTER_MARKER_COLORS } from 'reducers/compModels';


function* setupDefaultFilter(markers) {
  let filterMarkers = [];

  if (!markers) {
    markers = yield select(state => state.markers);
  }

  for (const marker of markers) {
    const { color, globalId, label } = marker;

    filterMarkers.push({
      color,
      label,
      markerId: globalId || marker.id,
      display: false,
      disabled: true
    });
  }

  return filterMarkers;
}

function* notebookFilterMarkers(highlights, markers) {
  let filterMarkerColors = [];
  let accountedForFilterColors = [];

  const defaultFilterColors = yield setupDefaultFilter(markers);

  loop1:
  for (const highlight of highlights) {
    const { markerId:_markerId } = highlight;

    if (accountedForFilterColors.length === 4) {
      break loop1;
    }

    if (!accountedForFilterColors.includes(_markerId)) {
      loop2:
      for (let i=0; i<defaultFilterColors.length; i++) {
        const { markerId } = defaultFilterColors[i];

        if (_markerId === markerId) {
          accountedForFilterColors.push(markerId);
          defaultFilterColors[i].display = true;
          defaultFilterColors[i].disabled = false;
          break loop2;
        }
      }
    }
  }

  filterMarkerColors = [ ...defaultFilterColors ];
  yield put({ type: SAVE_FILTER_MARKER_COLORS, data: filterMarkerColors });
}


export default notebookFilterMarkers;
